orders-planner-line-ui-schedules-cell(class="{selected: selected} {one: oneDayFlg} {updating: opts.updating} {outside: opts.outside} delivery_who_{opts.who}" onClick="{onClick}" onMouseOver="{onOver}" onMouseOut="{onOut}")
  span.left
  span.right
  span.top
  span.bottom
  span.dmy-memo
  span.drag(onMouseDown="{onDown}")
  orders-planner-line-ui-schedules-left(tag-scope="{this.tagScope}")
  orders-planner-line-ui-schedules-right(tag-scope="{this.tagScope}")
  script(type="typescript").
    this.mixin('orders.planner.line-ui.schedules-cell')
